import React from 'react'
import { Helmet } from 'react-helmet'
import ActiveCatalogue from '../../components/ActiveCatalogue/ActiveCatalogue'
import BrandLogoSlider from '../../components/BrandLogoSlider'
import MyRequestPage from '../../components/MyRequest/RequestDetails'
import Footer from '../../components/Footer'
import Header from '../../components/Header'

const MyRequestDetails = () => {
    return (
        <>
            <Helmet>
                <title>My Requests</title>
            </Helmet>
            <Header />
            <ActiveCatalogue />
            <MyRequestPage />
            <BrandLogoSlider />
            <Footer displayFooterTop={false} />
        </>
    )
}

export default MyRequestDetails